import {
    getField,
    updateField
} from "vuex-map-fields"
import {requestSubmit} from "../../api"
import {
    ADD_ROW, RESET_FORM
} from "../../constant-types"
import { defaultRemoveRowMutation, defaultSetFormsMutation } from "../../default-method"

const getDefaultState = () => {
    return {
        rows: [getDefaultRowState()],
        payment_total : 0,
        payment_total_after_qty_return : 0,
        has_return: false,
        purchase_id: '',
    }
}

const getDefaultRowState = (state) => { 
    let nominal = 0
    if (!state) {
        nominal = 0
    } else {
        nominal = ( state.has_return ? state.payment_total_after_qty_return : state.payment_total )- state.rows.reduce((prev, cur) => prev + cur.nominal, 0) // add remain
    }
    return {
        id: '',
        due_date: null,
        due_date_code: '',
        paid_date_time: null,
        from_user_cash_id: null,
        to: '',
        // nominal base on payment total if has return or not
        nominal,
        status_paid: false,
        memo: '',
        created_by_id: ''
    }
}

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.rows.push(getDefaultRowState(state))
        },
        ...defaultRemoveRowMutation,
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        ...defaultSetFormsMutation,
        updateField

    },
    // can async
    actions: {
        requestUpdate({commit, state, rootState}) {
            let formData = {
                payments: state.rows,
                payment_total : state.payment_total,
                payment_total_after_qty_return : state.payment_total_after_qty_return,
                has_return : state.has_return,
                // include proof as pictures
                pictures: rootState.pictureForm.pictures,
                new_pictures: rootState.pictureForm.new_pictures.map(p => ({
                    caption: p.caption, file: p.file
                }))
            }
            return requestSubmit(`purchase/${state.purchase_id}/payments`, formData, commit)
        }
    },
    // call variable with custom display
    getters: {
        getField,
        formReady: state => {
            //// ori : before
            //// paymentTotalIsNotExceed
            //return _.sumBy(state.rows, 'nominal') === state.payment_total

            let sumNominal = _.sumBy(state.rows, 'nominal')
            // user cash id should fill, when has nominal
            if ( state.rows.some(sp => !sp.from_user_cash_id) ) return false
            //if ( state.status_credit_payment ) {
                //// when is credit, nominal should not negative but allow zero for direct cash
                //if ( state.rows.some(sp => sp.nominal < 0 ) ) return false
                //if ( state.rows.some(sp => sp.nominal === 0 && !sp.status_paid ) ) return false
            //} else {
                //// when is cash, nominal should not negative or zero
                //if ( state.rows.some(sp => sp.nominal <= 0 ) ) return false
            //}
            // sum of nominal should not zero or negative
            if (sumNominal <= 0) return false

            // paymentTotalIsNotExceed
            if (state.has_return) {
                return sumNominal === state.payment_total_after_qty_return
            } else {
                return sumNominal === state.payment_total
            }
        }
    }
})

